/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_canvas_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signature drawing area`)
};

const es_sig_canvas_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Área de dibujo de firma`)
};

const de_sig_canvas_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signatur-Zeichenbereich`)
};

const nl_sig_canvas_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekengebied voor handtekening`)
};

const fr_sig_canvas_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zone de dessin de signature`)
};

const it_sig_canvas_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Area disegno firma`)
};

const pt_br2_sig_canvas_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Área de desenho de assinatura`)
};

const pt_sig_canvas_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Área de desenho de assinatura`)
};

const ja_sig_canvas_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`署名描画エリア`)
};

const zh_sig_canvas_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`签名绘制区域`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_canvas_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_canvas_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_canvas_label", locale)
	if (locale === "en") return en_sig_canvas_label(inputs)
	if (locale === "es") return es_sig_canvas_label(inputs)
	if (locale === "de") return de_sig_canvas_label(inputs)
	if (locale === "nl") return nl_sig_canvas_label(inputs)
	if (locale === "fr") return fr_sig_canvas_label(inputs)
	if (locale === "it") return it_sig_canvas_label(inputs)
	if (locale === "pt-BR") return pt_br2_sig_canvas_label(inputs)
	if (locale === "pt") return pt_sig_canvas_label(inputs)
	if (locale === "ja") return ja_sig_canvas_label(inputs)
	return zh_sig_canvas_label(inputs)
};